const checkModuleEnabled = [
  '$q',
  '$state',
  '$rootScope',
  ($q, $state, $rootScope) => {
    const deferred = $q.defer()

    $rootScope.getCompanyFeaturesAndAddons().then(configs => {
      if (configs.features['ARTS.ACCESS']) {
        deferred.resolve()
      } else {
        deferred.reject()
      }
    })

    return deferred.promise.catch(() => {
      $state.go('home')
    })
  }
]

const checkSocialMediaEnabled = [
  '$q',
  '$state',
  '$rootScope',
  ($q, $state, $rootScope) => {
    const deferred = $q.defer()

    $rootScope.getEnableSocialMedia(true).then(isEnableSocialMedia => {
      if (isEnableSocialMedia) {
        deferred.resolve()
      } else {
        deferred.reject()
      }
    })

    return deferred.promise.catch(() => {
      $state.go('user.arts')
    })
  }
]

const onEnterUserModule = ($rootScope, $stateParams, $state, route) => {
  const checkAccess = async () => {
    if (!$rootScope.isUser()) return
    $state.go(route, $stateParams, { reload: true })
  }
  checkAccess()
}

/* @ngInject */
function routes ($stateProvider) {
  $stateProvider
    .state('arts', {
      url: '/arts',
      abstract: true,
      resolve: {
        checkModuleEnabled
      },
      views: {
        '': {
          templateUrl: '/arts/arts.html?$$REVISION$$',
          controller: 'ArtsController'
        }
      }
    })
    .state('arts.me', {
      parent: 'arts',
      url: '/me?page&art',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'me@arts': {
          templateUrl: '/arts/pages/art-list/art-list.html?$$REVISION$$',
          controller: 'ArtListController'
        },
        'secondLevelMenu@arts.me': {
          templateUrl: '/arts/pages/art-list/art-list-sidebar-options.html?$$REVISION$$'
        },
        'dashboardSidebarOptions@arts.me': {
          templateUrl: '/arts/arts-sidebar-menu.html?$$REVISION$$'
        }
      },
      data: {
        selectedMenuId: 1
      }
    })
    .state('arts.companyTemplates', {
      parent: 'arts',
      url: '/company/templates?template&search&page&previewId',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'companyTemplates@arts': {
          templateUrl: '/arts/pages/company-template-list/company-template-list.html?$$REVISION$$',
          controller: 'CompanyTemplateListController'
        },
        'secondLevelMenu@arts.companyTemplates': {
          templateUrl: '/arts/pages/company-template-list/company-template-list-sidebar-options.html?$$REVISION$$'
        },
        'dashboardSidebarOptions@arts.companyTemplates': {
          templateUrl: '/arts/arts-sidebar-menu.html?$$REVISION$$'
        }
      },
      data: {
        selectedMenuId: 3,
        from: null
      },
      onEnter: ($rootScope, $stateParams, $state) => onEnterUserModule($rootScope, $stateParams, $state, 'user.arts')
    })
    .state('arts.companyApprovals', {
      parent: 'arts',
      url: '/company/approvals?art&search&selectedTab&page',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'companyApprovals@arts': {
          templateUrl: '/arts/pages/approval-list/approval-list.html?$$REVISION$$',
          controller: 'ApprovalListController'
        },
        'secondLevelMenu@arts.companyApprovals': {
          templateUrl: '/arts/pages/approval-list/approval-list-sidebar-options.html?$$REVISION$$'
        },
        'dashboardSidebarOptions@arts.companyApprovals': {
          templateUrl: '/arts/arts-sidebar-menu.html?$$REVISION$$'
        }
      },
      data: {
        selectedMenuId: 4,
        from: null
      },
      onEnter: ($rootScope, $stateParams, $state) => onEnterUserModule($rootScope, $stateParams, $state, 'user.arts')
    })
    .state('arts.collection', {
      parent: 'arts',
      url:
        '/collection/:id?template&search&formatId&customizationLevel&needApproval&groupId&isArchived&artTagIds&tab&createdAt&templateExpiration&page&previewId&edit',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'collection@arts': {
          templateUrl: '/arts/pages/collection-list/collection-list.html?$$REVISION$$',
          controller: 'CollectionListController'
        },
        'secondLevelMenu@arts.collection': {
          templateUrl: '/arts/pages/product-list/product-list-sidebar-options.html?$$REVISION$$'
        },
        'dashboardSidebarOptions@arts.collection': {
          templateUrl: '/arts/arts-sidebar-menu.html?$$REVISION$$'
        }
      },
      data: {
        selectedMenuId: 2
      },
      params: {
        from: null,
        pageHistory: [],
        root: null
      },
      onEnter: ($rootScope, $stateParams, $state) => onEnterUserModule($rootScope, $stateParams, $state, 'user.collection')
    })
    .state('arts.templates', {
      parent: 'arts',
      url:
        '/templates?template&search&formatId&customizationLevel&needApproval&groupId&isArchived&artTagIds&tab&createdAt&templateExpiration&page&previewId',
      reloadOnSearch: false,
      resolve: {
        checkModuleEnabled
      },
      views: {
        'templates@arts': {
          templateUrl: '/arts/pages/product-list/product-list.html?$$REVISION$$',
          controller: 'ProductListController'
        },
        'secondLevelMenu@arts.templates': {
          templateUrl: '/arts/pages/product-list/product-list-sidebar-options.html?$$REVISION$$'
        },
        'dashboardSidebarOptions@arts.templates': {
          templateUrl: '/arts/arts-sidebar-menu.html?$$REVISION$$'
        }
      },
      data: {
        selectedMenuId: 2
      },
      params: {
        section: null
      },
      onEnter: ($rootScope, $stateParams, $state) => onEnterUserModule($rootScope, $stateParams, $state, 'user.arts')
    })
    .state('arts.templatesEdit', {
      parent: 'arts',
      url: '/templates/edit',
      resolve: {
        checkModuleEnabled
      },
      views: {
        'templatesEdit@arts': {
          templateUrl: '/arts/pages/arts-page-customization/arts-page-customization.html?$$REVISION$$',
          controller: 'ArtsPageCustomizationController'
        }
      },
      data: {
        selectedMenuId: 2
      }
    })
    .state('user', {
      url: '/arts/user?socialMediaStatus?previewId',
      resolve: {
        checkModuleEnabled
      },
      reloadOnSearch: true,
      views: {
        '': {
          templateUrl: '/arts/pages/user/user.html?$$REVISION$$',
          controller: 'UserController'
        },
        'userSecondLevelMenu@user': {
          templateUrl: '/arts/pages/user/user-sidebar-menu.html?$$REVISION$$'
        },
        'userSidebarOptions@user': {
          templateUrl: '/arts/pages/user/user-sidebar-options.html?$$REVISION$$'
        }
      },
      onEnter: function ($rootScope, $stateParams, $state) {
        const checkAccess = async () => {
          try {
            const user = await $rootScope.getUser()
            if (!$rootScope.isUser(user)) {
              await $state.go('arts.templates', $stateParams, { reload: true })
            }
          } catch (error) {
            await $state.go('arts.templates', $stateParams, { reload: true })
          }
        }
        return checkAccess()
      }
    })
    .state('user.arts', {
      url: '/',
      parent: 'user',
      reloadOnSearch: false,
      views: {
        'content@user': {
          templateUrl: '/arts/pages/user/arts/user-arts.html?$$REVISION$$',
          controller: 'UserArtsController'
        },
        'search@user.arts': {
          templateUrl: '/arts/pages/user/arts/search/user-search.html?$$REVISION$$',
          controller: 'UserArtsSearchController'
        }
      },
      params: {
        damRedirect: false
      }
    })
    .state('user.latestNews', {
      parent: 'user',
      url: '/latest-news',
      views: {
        'content@user': {
          templateUrl: '/arts/pages/user/latest-news/user-latest-news.html?$$REVISION$$',
          controller: 'UserLatestNewsController'
        }
      }
    })
    .state('user.collection', {
      parent: 'user',
      url: '/collection/:id',
      reloadOnSearch: false,
      views: {
        'content@user': {
          templateUrl: '/arts/pages/user/collection/user-collection.html?$$REVISION$$',
          controller: 'UserCollectionController'
        }
      }
    })
    .state('publicDownload', {
      url: '/arts/download/:uuid',
      public: true,
      views: {
        '': {
          templateUrl: '/arts/pages/public-download/public-download.html?$$REVISION$$',
          controller: 'PublicDownloadController'
        }
      }
    })
    .state('publicFolder', {
      url: '/arts/folder/:uuid',
      public: true,
      views: {
        '': {
          templateUrl: '/arts/pages/public-campaign/public-campaign.html?$$REVISION$$',
          controller: 'PublicCampaignController'
        }
      }
    })
    .state('arts.socialMedia', {
      parent: 'arts',
      url: '/social-media?socialMediaStatus',
      resolve: {
        checkModuleEnabled,
        checkSocialMediaEnabled
      },
      params: {
        templateIds: null,
        template: null
      },
      reloadOnSearch: true,
      views: {
        'socialMedia@arts': {
          templateUrl: '/arts/pages/social-media/social-media.html?$$REVISION$$',
          controller: 'SocialMediaController'
        }
      },
      onEnter: function ($rootScope, $stateParams, $state) {
        const checkAccess = async () => {
          const isNotUser = !$rootScope.isUser()
          const hasNotUserAccounts = !$rootScope?.oUser?.socialAccounts?.length

          if (isNotUser || hasNotUserAccounts) {
            $state.go('user.arts', $stateParams, { reload: true })
          }
        }
        checkAccess()
      }
    })
}

export const artsRoutes = routes
